<template>
  <div>
    <success-fade-alert ref="alert" :msg="alert.success" />
    <b-modal
      id="modal-prevent-closing"
      ref="configVehicleModal"
      title="Configurador"
      size="md"
    >
      <!-- <div v-for="selected in selectedType" :key="selected.value">
        <label for="">{{ selected.text }}</label>
      </div> -->
      <label for="">Selecione os tipos de veículo</label>
      <multiselect
        id="selectSteps"
        class="select-field"
        v-model="selectedType"
        label="text"
        track-by="value"
        placeholder="Selecione os tipos de veículo"
        :close-on-select="false"
        :showLabels="false"
        :multiple="true"
        :options="vehicleTypeOpt"
        @input="onChangeValues"
      >
      </multiselect>
      <template #modal-footer="{ cancel }">
        <div class="right">
          <b-button
            class="ml-2"
            :disabled="isSaving"
            variant="green"
            @click="save()"
          >
            {{ $t("geral.confirm") }}
          </b-button>
          <b-button class="ml-2" variant="danger" @click="cancel()">
            {{ $t("geral.cancel") }}
          </b-button>
        </div>
      </template>
      <!-- <div>{{ model }}</div> -->
      <!-- <div>allType: {{ allType }}</div> -->
      <!-- <div>selectedType: {{ selectedType }}</div> -->
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "ConfigSaveVehicleModal",
  components: {
    SuccessFadeAlert: () => import("@/components/SuccessFadeAlert.vue"),
  },
  data() {
    return {
      alert: {
        error: "",
        success: "Cadastro salvo com sucesso",
      },
      allType: [],
      vehicleTypeOpt: [],
      model: {},
      selectedType: [],
      isSaving: false,
    };
  },
  methods: {
    open() {
      this.getAllVehicleType();
      this.loadData();
      this.$refs.configVehicleModal.show();
    },
    getAllVehicleType() {
      this.$apiVehicle.get("/vehicleType/listAllType/").then((response) => {
        this.allType = response.data;
        this.allType.forEach((type) => {
          this.vehicleTypeOpt.push({
            value: type.id,
            text: type.name,
          });
        });
      });
    },
    loadData() {
      this.$apiVehicle
        .get("/vehicleConfiguration/configurationByCompanyId/")
        .then((response) => {
          this.model = response.data;
          if (this.model.releasedType) {
            this.model.releasedType.forEach((value) => {
              this.vehicleTypeOpt.find((type) => {
                if (type.value === value.vehicleTypeId) {
                  this.selectedType.push(type);
                }
              });
            });
          }
        });
    },
    onChangeValues(values) {
      this.model.releasedType = values.map((value) => ({
        vehicleTypeId: value.value,
      }));
    },
    save() {
      this.isSaving = true;
      this.$apiVehicle
        .post("/vehicleConfiguration/save/", this.model)
        .then((response) => {
          this.isSaving = false;
          this.$refs.alert.show();
        })
        .catch((error) => {
          this.isSaving = false;
          console.error("Erro ao salvar os valores de índice:", error);
        });
    },
  },
  computed: {
    // Your computed properties here
  },
  mounted() {
    // Your mounted hook code here
  },
};
</script>

<style scoped>
.right {
  text-align: right;
  width: 100%;
}
</style>